import * as R from "ramda";
import * as React from "react";

import { courseUnitViews } from "../../../../utils/courseViews";
import { extendView } from "../../../../utils/courseViewUtils";
import { PreferredLocale } from "../../../../utils/locales";
import { findComponent } from "../../../course-author/helpers/patches/util";
import {
  CourseComponentTag,
  CourseView,
  ICourseEditOperations,
  ICourseNavigationOperations,
  ICourseUnit,
  IDisplayGroups,
  IFullCourse,
  Slide,
} from "../../../course-author/types";
import CourseComponentList from "../CourseComponentsList";
import NewComponentLink from "../NewComponentLink";
import ComponentLink from "./ComponentLink";

interface IUnitsListProps {
  course: IFullCourse;
  currentLocale: PreferredLocale;
  displayedComponent: Slide | null;
  displayGroups: IDisplayGroups;
  editOperations: ICourseEditOperations;
  navigationOperations: ICourseNavigationOperations;
  rootUrl: string;
  unitPath: Array<CourseView<ICourseUnit, IFullCourse>>;
}

const UnitsHeader = () => <div>Units</div>;
const navigateTo = (props: IUnitsListProps, unit: ICourseUnit) => () => {
  props.navigationOperations.setPath([...props.unitPath, extendView(props.course, R.last(props.unitPath), unit)]);
  props.navigationOperations.setDisplayedComponent(unit)();
};

const UnitsList: React.FC<IUnitsListProps> = props => {
  const { displayGroups, displayedComponent, editOperations, unitPath } = props;
  const units: ICourseUnit[] = unitsFromDisplayGroups(displayGroups);
  return (
    <CourseComponentList renderHeader={UnitsHeader}>
      {units.map((unit, i) => (
        <ComponentLink
          component={unit}
          currentLocale={props.currentLocale}
          deleteFn={editOperations.deleteComponent(unitPath, unit)}
          key={i}
          onClick={navigateTo(props, unit)}
          selected={unit === displayedComponent}
          to={`${props.rootUrl}?position=${findComponent(props.course, props.unitPath, unit)}`}
        >
          {courseUnitViews.localizedTitle(unit, props.currentLocale)}
        </ComponentLink>
      ))}
      <NewComponentLink
        title={`New Unit`}
        onClick={editOperations.createComponent(unitPath, CourseComponentTag.Unit)}
      />
    </CourseComponentList>
  );
};

export default UnitsList;

function unitsFromDisplayGroups(displayGroups: IDisplayGroups): ICourseUnit[] {
  return R.compose<IDisplayGroups, Array<Nullable<ICourseUnit>>, Array<Nullable<ICourseUnit>>, ICourseUnit[]>(
    R.filter(R.compose(R.not, R.isNil)),
    R.filter(R.compose(R.not, courseUnitViews.deleted)),
    R.propOr<ICourseUnit[]>([], CourseComponentTag.Unit)
  )(displayGroups);
}
